import { CredentialsSignin as CredentialsSigninError } from 'next-auth'

/**
 * Some of these errors are used not only in the Credentials provider, but also in the provider-agnostic `signin` callback.
 *
 * For Credentials provider, we want to handle these errors on the same page.
 * For OAuth providers, we redirect user to the special error page.
 */
export const customCredentialsErrorCodes = {
  credentials_validation_error: 'credentials_validation_error',
  credentials_incorrect_credentials_error: 'credentials_incorrect_credentials_error',
  credentials_user_inactive_error: 'credentials_user_inactive_error',
  credentials_user_pending_error: 'credentials_user_pending_error',
  credentials_user_role_error: 'credentials_user_role_error',
  credentials_unknown_error: 'credentials_unknown_error',
} as const

/**
 * Failed to parse the input body.
 */
export class CredentialsValidationError extends CredentialsSigninError {
  override code = customCredentialsErrorCodes.credentials_validation_error
}

/**
 * Credentials are incorrect for any reason.
 */
export class CredentialsIncorrectCredentialsError extends CredentialsSigninError {
  override code = customCredentialsErrorCodes.credentials_incorrect_credentials_error
}

/**
 * User has inactive status.
 */
export class CredentialsUserInactiveError extends CredentialsSigninError {
  override code = customCredentialsErrorCodes.credentials_user_inactive_error
}

/**
 * User has pending status.
 */
export class CredentialsUserPendingError extends CredentialsSigninError {
  override code = customCredentialsErrorCodes.credentials_user_pending_error
}

/**
 * User has one of staff roles.
 */
export class CredentialsUserRoleError extends CredentialsSigninError {
  override code = customCredentialsErrorCodes.credentials_user_role_error
}

/**
 * Internal fatal error.
 */
export class CredentialsUnknownError extends CredentialsSigninError {
  override code = customCredentialsErrorCodes.credentials_unknown_error
}

export const oAuthErrorParamName = 'OAuthError'

export const authErrorURL = '/auth-error'

export const buildOAuthErrorURL = (code: keyof typeof customCredentialsErrorCodes) => {
  const params = new URLSearchParams({
    error: oAuthErrorParamName,
    code,
  })

  return `${authErrorURL}?${params}`
}
